import type { PublicHolidayRegionCode } from './publicHolidayTypes';

export const PUBLIC_HOLIDAY_YEAR_BOUNDS = { minimum: 2000, maximum: 2100 } as const;

export const isSupportedHolidayYear = (year: number): boolean =>
  Number.isInteger(year) && year >= PUBLIC_HOLIDAY_YEAR_BOUNDS.minimum && year <= PUBLIC_HOLIDAY_YEAR_BOUNDS.maximum;

export interface PublicHolidayRegion {
  code: PublicHolidayRegionCode;
  label: string;
  locale: string;
  jurisdictionLabel: string;
  allJurisdictionsLabel: string;
  jurisdictions: { value: string; label: string }[];
}

export interface PublicHolidayPeriodPreset {
  presetLabel: string;
  presetValue: string;
  presetOptionLabel: string;
  presetStart: string;
  presetEnd: string;
}

export const PUBLIC_HOLIDAY_REGIONS: Record<PublicHolidayRegionCode, PublicHolidayRegion> = {
  AU: { code: 'AU', label: 'Australia', locale: 'en-AU', jurisdictionLabel: 'State or territory', allJurisdictionsLabel: 'All states and territories', jurisdictions: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'].map((value) => ({ value, label: value })) },
  NZ: { code: 'NZ', label: 'New Zealand', locale: 'en-NZ', jurisdictionLabel: 'Jurisdiction', allJurisdictionsLabel: 'National only', jurisdictions: [] },
  US: { code: 'US', label: 'United States', locale: 'en-US', jurisdictionLabel: 'Jurisdiction', allJurisdictionsLabel: 'National only', jurisdictions: [] },
  UK: { code: 'UK', label: 'United Kingdom', locale: 'en-GB', jurisdictionLabel: 'UK jurisdiction', allJurisdictionsLabel: 'All UK jurisdictions', jurisdictions: [{ value: 'EAW', label: 'England and Wales' }, { value: 'SCT', label: 'Scotland' }, { value: 'NIR', label: 'Northern Ireland' }] },
};

export const PUBLIC_HOLIDAY_REGION_OPTIONS = Object.values(PUBLIC_HOLIDAY_REGIONS).map(({ code, label }) => ({ value: code, label }));

export const normaliseJurisdiction = (regionCode: PublicHolidayRegionCode, jurisdictionCode: string): string =>
  PUBLIC_HOLIDAY_REGIONS[regionCode].jurisdictions.some(({ value }) => value === jurisdictionCode) ? jurisdictionCode : '';

export const publicHolidayPeriodPreset = (_regionCode: PublicHolidayRegionCode, today: Date = new Date()): PublicHolidayPeriodPreset => {
  const year = today.getFullYear();
  return {
    presetLabel: 'Calendar year',
    presetValue: String(year),
    presetOptionLabel: `${year} (1 Jan - 31 Dec ${year})`,
    presetStart: `${year}-01-01`,
    presetEnd: `${year}-12-31`,
  };
};
